export default "__VITE_ASSET__DS$5TX_B__"